import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { COMMAND_CENTER_RATE_SHEET_MOVEMENT_ACTION_TYPE } from '../actions/rateSheetMovement.actions';

const initialState = null;

const rateSheetMovementReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case COMMAND_CENTER_RATE_SHEET_MOVEMENT_ACTION_TYPE.SET_RATE_SHEET_MOVEMENT:
        return payload ?? initialState;

      case RESET_STATE:
        return initialState;

      default:
        return draft;
    }
  });

export default rateSheetMovementReducer;
